import { Route, Routes, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/auth/LoginPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { MpgGridPocPage } from './pages/poc/MpgGridPocPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { ProductListPage } from './pages/products/ProductListPage';
import { ProductFormPage } from './pages/products/ProductFormPage';
import { LotListPage } from './pages/lots/LotListPage';
import { LotFormPage } from './pages/lots/LotFormPage';
import { CustomerListPage } from './pages/customers/CustomerListPage';
import { CustomerFormPage } from './pages/customers/CustomerFormPage';
import { SupplierListPage } from './pages/suppliers/SupplierListPage';
import { SupplierFormPage } from './pages/suppliers/SupplierFormPage';
import { PscListPage } from './pages/psc/PscListPage';
import { PscFormPage } from './pages/psc/PscFormPage';
import { LnpListPage } from './pages/lnp/LnpListPage';
import { LnpFormPage } from './pages/lnp/LnpFormPage';
import { MpgListPage } from './pages/mpg/MpgListPage';
import { MpgFormPage } from './pages/mpg/MpgFormPage';
import { MssListPage } from './pages/mss/MssListPage';
import { MssFormPage } from './pages/mss/MssFormPage';
import { MsfListPage } from './pages/msf/MsfListPage';
import { MsfFormPage } from './pages/msf/MsfFormPage';
import { InvListPage } from './pages/inv/InvListPage';
import { InvFormPage } from './pages/inv/InvFormPage';
import { RequireAuth } from './lib/RequireAuth';
import { AppShell } from './components/AppShell';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/products" element={<ProductListPage />} />
        <Route path="/products/new" element={<ProductFormPage />} />
        <Route path="/products/:id/edit" element={<ProductFormPage />} />
        <Route path="/lots" element={<LotListPage />} />
        <Route path="/lots/new" element={<LotFormPage />} />
        <Route path="/lots/:id/edit" element={<LotFormPage />} />
        <Route path="/customers" element={<CustomerListPage />} />
        <Route path="/customers/new" element={<CustomerFormPage />} />
        <Route path="/customers/:id/edit" element={<CustomerFormPage />} />
        <Route path="/suppliers" element={<SupplierListPage />} />
        <Route path="/suppliers/new" element={<SupplierFormPage />} />
        <Route path="/suppliers/:id/edit" element={<SupplierFormPage />} />
        <Route path="/documents/psc" element={<PscListPage />} />
        <Route path="/documents/psc/new" element={<PscFormPage />} />
        <Route path="/documents/psc/:id/edit" element={<PscFormPage />} />
        <Route path="/documents/lnp" element={<LnpListPage />} />
        <Route path="/documents/lnp/new" element={<LnpFormPage />} />
        <Route path="/documents/lnp/:id/edit" element={<LnpFormPage />} />
        <Route path="/documents/mpg" element={<MpgListPage />} />
        <Route path="/documents/mpg/:id/edit" element={<MpgFormPage />} />
        <Route path="/documents/mss" element={<MssListPage />} />
        <Route path="/documents/mss/new" element={<MssFormPage />} />
        <Route path="/documents/mss/:id/edit" element={<MssFormPage />} />
        <Route path="/documents/msf" element={<MsfListPage />} />
        <Route path="/documents/msf/new" element={<MsfFormPage />} />
        <Route path="/documents/msf/:id/edit" element={<MsfFormPage />} />
        <Route path="/documents/inv" element={<InvListPage />} />
        <Route path="/documents/inv/new" element={<InvFormPage />} />
        <Route path="/documents/inv/:id/edit" element={<InvFormPage />} />
        <Route path="/poc/mpg-grid" element={<MpgGridPocPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
